// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"44":"6b3e2a1d","565":"71edd35f","594":"54ecfe10","926":"cf6a953d"}[chunkId] + ".js";
};